import { FacebookShareButton, TwitterShareButton } from 'react-share';

import { SocialFb } from '@/assets';
import { IconShare, IconTwitter } from '@/components/assets';
import { useAuth } from '@/provider/UserProvider';
import TooltipCustom from '@/components/tooltip-custom';

const SharePost: React.FC<any> = ({ asset, domain, postId }) => {
  const { isLogin } = useAuth();

  return (
    <TooltipCustom
      content={
        isLogin ? (
          <div className="flex flex-col gap-3 p-1">
            <TwitterShareButton
              url={' '}
              title={`My artwork with #aiRight: \n${asset?.name} - ${domain}/feed/${postId} \n$ORAI $AIRI #NFT`}
            >
              <div className="flex gap-2 rounded-3xl p-2 hover:cursor-pointer hover:bg-gray-100">
                <IconTwitter />
                Share on Twitter
              </div>
            </TwitterShareButton>
            <FacebookShareButton
              url={`${domain}/feed/${postId}`}
              hashtag="#ORAI #AIRIGHT"
              title={`My artwork with #aiRight: \n${asset?.name} - ${domain}/feed/${postId}`}
            >
              <div className="flex gap-2 rounded-3xl p-2 hover:cursor-pointer hover:bg-gray-100">
                {' '}
                <SocialFb />
                Share on Facebook
              </div>
            </FacebookShareButton>
          </div>
        ) : (
          <div>Sign in to share</div>
        )
      }
      delay={0}
      closeDelay={0}
      showArrow
    >
      <div className="flex items-center justify-center gap-2 rounded-[32px] px-3.5 py-2.5 hover:cursor-pointer hover:bg-gray-100">
        <IconShare />
        <span>Share</span>
      </div>
    </TooltipCustom>
  );
};
export default SharePost;
